const isDevelopment = process.env.NODE_ENV === 'development';

export const API_BASE_URL = process.env.REACT_APP_API_URL || (isDevelopment ? "http://localhost:5001/api" : "https://server.turbo.sd/api")
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || (isDevelopment ? "http://localhost:5001" : "https://server.turbo.sd")
